import React from 'react';
import { MapPin, Phone, Mail, Clock, Instagram } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer 
      id="contact"
      className="bg-[#8B2942] pt-20 pb-8"
      data-testid="footer-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <h3 className="font-['Playfair_Display'] text-2xl mb-6">
              <span className="text-white">PAVILLON</span>
              <span className="text-white/80"> de ROZE</span>
            </h3>
            {/* Social Links */}
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/pavillonderoze" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/30 flex items-center justify-center text-white/70 hover:text-white hover:border-white transition-all"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Address */}
          <div>
            <h4 className="text-white uppercase tracking-widest text-sm mb-6">
              {t('footer.address')}
            </h4>
            <div className="flex items-start gap-3 text-white/70">
              <MapPin size={18} className="text-white mt-1 flex-shrink-0" />
              <div>
                <p>Hotel Villa Roze</p>
                <p>Uliha iela 32</p>
                <p>Liepāja, LV-3401</p>
                <p>Latvia</p>
              </div>
            </div>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="text-white uppercase tracking-widest text-sm mb-6">
              {t('footer.hours')}
            </h4>
            <div className="flex items-start gap-3 text-white/70">
              <Clock size={18} className="text-white mt-1 flex-shrink-0" />
              <p>{t('footer.hoursText')}</p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white uppercase tracking-widest text-sm mb-6">
              {t('footer.contact')}
            </h4>
            <div className="space-y-4">
              <a 
                href="tel:+37126590606" 
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                data-testid="contact-phone"
              >
                <Phone size={18} className="text-white" />
                <span>+371 26 590 606</span>
              </a>
              <a 
                href="mailto:pavillon@parkhotelliepaja.lv" 
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                data-testid="contact-email"
              >
                <Mail size={18} className="text-white" />
                <span>pavillon@parkhotelliepaja.lv</span>
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Pavillon de Roze. {t('footer.rights')}.
            </p>
            <a 
              href="https://rozehotelgroup.lv" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/60 text-sm hover:text-white transition-colors"
              data-testid="footer-hotel-link"
            >
              Hotel Villa Roze
            </a>
            <a 
              href="/admin" 
              className="text-white/30 text-xs hover:text-white/60 transition-colors mt-4 block"
              data-testid="footer-admin-link"
            >
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
